import React from "react";
import { Search } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

// Find Appointment sub-tab. Given a search query and a list of matched
// appointments, renders a table and opens the calendar on the appointment's
// date when the operator clicks a row.
export default function FindAppointmentTab({ query, setQuery, results, onOpenDate }) {
  return (
    <Card className="rounded-lg">
      <CardContent className="p-4">
        <div className="relative max-w-md mb-4">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search by customer name, email, or WhatsApp…"
            className="pl-9"
            data-testid="find-appt-input"
          />
        </div>
        <div className="rounded-md border border-border overflow-hidden">
          <div className="grid grid-cols-[1.4fr_1.6fr_1fr_1fr] gap-2 bg-secondary/40 px-3 py-2 text-[11px] uppercase tracking-wider text-muted-foreground">
            <span>Customer</span><span>Service</span><span>When</span><span>Status</span>
          </div>
          {results.length === 0 && (
            <p className="p-6 text-sm text-muted-foreground text-center">Type to search for an appointment.</p>
          )}
          {results.map((a) => (
            <button
              key={a.id}
              onClick={() => onOpenDate(new Date(a.start_iso))}
              className="grid grid-cols-[1.4fr_1.6fr_1fr_1fr] gap-2 px-3 py-2 text-sm border-t border-border hover:bg-secondary/30 text-left w-full"
              data-testid={`find-row-${a.id}`}
            >
              <span className="truncate">{a.customer_name || "Walk-in"}</span>
              <span className="truncate text-muted-foreground">{a.service_name}</span>
              <span>{new Date(a.start_iso).toLocaleString("en-GB", { timeZone: "Asia/Makassar", dateStyle: "short", timeStyle: "short" })}</span>
              <span className="capitalize">{a.status?.replace("_", " ")}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
